import { Navigate } from 'react-router-dom';

// Only lets SuperAdmin sessions through. This just keeps lab users out of
// the UI; the API enforces the role on every super admin call.
export default function SuperAdminGuard({ children }) {
  const token = sessionStorage.getItem('token');
  const role = sessionStorage.getItem('User_Role');

  if (!token) return <Navigate to="/" replace />;
  if (role !== 'SuperAdmin') return <Navigate to="/Home/Dashboard" replace />;
  return children;
}
